<template>
  <span>
    <i class="fa" :class="`fa-${value ? 'check' : 'times'}`"></i>
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    }
  }
}
</script>
